import axios from "axios";

// Route all API calls through this web app's own server (same-origin), which proxies
// server-to-server to the mobile backend. This removes browser CORS from the equation
// entirely (the mobile backend's preflight/CORS has been unreliable).
const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/proxy`;

// Emergent-managed Google Auth login page
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AUTH_URL = "https://auth.emergentagent.com/";

const TOKEN_KEY = "blessed_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

// Bearer-token auth (no cookies), so credentials mode stays 'omit' to satisfy
// the backend's wildcard CORS (Access-Control-Allow-Origin: *).
export const api = axios.create({ baseURL: API_BASE, withCredentials: false });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Extract a bearer token from the /auth/session response (shape varies)
export const extractToken = (data) => {
  if (!data || typeof data !== "object") return null;
  return (
    data.session_token ||
    data.token ||
    data.access_token ||
    data.access ||
    data.bearer_token ||
    data.sessionToken ||
    data.user?.session_token ||
    data.session?.session_token ||
    data.data?.session_token ||
    null
  );
};
